import { useHistory } from "react-router-dom";
import { ScreenGreeting, TicketStepper } from "../../../../Components/Molecules";
import { PaperDiv } from "../styles";
import intl from "react-intl-universal";

const AddTicket = () => {
    const history = useHistory();
    
    return (
        <>
            <ScreenGreeting
                title={intl.get(`words.ticket`)}
                subTitle={intl.get(`phrases.ticketForWho`)}
            />

            <PaperDiv>
                <TicketStepper
                    onClose={() => {
                        history.push("/boletos");
                    }}
                    refreshList={() => {}}
                    
                />
            </PaperDiv>
        </>
    )
}

export {
    AddTicket
}